import request from '@/utils/request'

export function listBanner(query) {
    return request({
        url: '/oauth/server-oauth/slideItems/selectMyBanner',
        method: 'post',
        data: query
    })
}

export function listNewsInfo(query) {
    return request({
        url: '/system/server-newsInfo/info/list',
        method: 'get',
        params: query
    })
}

// 查询新闻资讯详细
export function getInfo(id) {
    return request({
        url: '/system/server-newsInfo/info/' + id,
        method: 'get'
    })
}

export function menHuClientList(query) {
    return request({
        url: '/oauth/server-exam/registeredClient/menHuMutiClientList',
        method: 'get',
        params: query
    })
}

// 获取客户端应用列表 简单排序
export function menHuClientListBySort(params) {
    return request({
        url: '/oauth/server-exam/registeredClient/app/client/list',
        method: 'get',
        params
    })
}

export function menHuClientListByType() {
    return request({
        url: '/oauth/server-exam/registeredClient/app/list',
        method: 'get'
    })
}

export function menHuClientTypeList() {
    return request({
        url: '/oauth/server-exam/registeredClient/app/list2',
        method: 'get'
    })
}

export function getClient(query) {
    return request({
        url: '/oauth/server-exam/registeredClient/menHuClientDetail',
        method: 'get',
        params: query
    })
}

export function getClientById(id) {
    return request({
        url: `/oauth/server-exam/registeredClient/${id}`,
        method: 'get'
    })
}

// 获取app下载链接(app下载页使用)
export function getAppDownLoadUrl() {
    return request({
        url: '/oauth/server-oauth/version/app/lastPackage/',
        method: 'get'
    })
}

// 获取操作指南列表
export function getGuideList(query) {
    return request({
        url: '/oauth/server-oauth/operationManual/list',
        method: 'get',
        params: query
    })
}

// 获取专题列表
export function getTopicList() {
    return request({
        url: `/system/server-system/topic/home/list`,
        method: 'get'
    })
}

// 获取指定专题列表
export function getTopicListById(params) {
    return request({
        url: `/system/server-system/topic/home/list/info`,
        method: 'get',
        params: params
    })
}

// 获取错题本列表
export function getWrongQuestionList(params) {
    return request({
        url: `/oauth/server-oauth/wrongQuestion/list`,
        method: 'get',
        params: params
    })
}

// 获取用户是否是会员
export function checkUserFeatures(params) {
    return request({
        url: `/system/server-system/user-features/check`,
        method: 'get',
        params: params
    })
}

// 获取北教下载Code
export function getTotpCode(params) {
    return request({
        url: `/oauth/server-oauth/wrongQuestion/getTotpCode`,
        method: 'get',
        params: params
    })
}

// 获取会员
export function getPlus() {
    return request({
        url: `/system/server-system/addvipmember`,
        method: 'post'
    })
}

// 获取首页展示栏目
export function getHomeColumn() {
    return request({
        url: `/system/server-system/appColumn/getColumnRoleList`,
        method: 'get'
    })
}

// 获取学习资料分类
export function getLearningResourcesCategory() {
    return request({
        url: `/system/server-system/studyType/list`,
        method: 'get',
        params: {
            status: 1  // 1: 上架
        }
    })
}

// 获取学习资料列表 
export function getLearningResourcesList(params) {
    return request({
        url: `/system/server-system/studyInformation/getListByUser`,
        method: 'get',
        params
    })
}

// 获取学习资料详情
export function getLearningResourcesDetail(id) {
    return request({
        url: `/system/server-system/studyInformation/${id}`,
        method: 'get'
    })
}

// 获取同步课程分类
export function getSyncCourseCategory() {
    return request({
        url: `/system/server-system/productMenu/getCourseMenuList`,
        method: 'get'
    })
}

// 获取同步课程列表
export function getSyncCourseList(params) {
    return request({
        url: `/system/server-system/course/getSyncCourseList`,
        method: 'get',
        params
    })
}

// 获取同步课程详情
export function getSyncCourseDetail(id) {
    return request({
        url: `/system/server-system/course/getSyncCoursetInfo?productId=${id}`,
        method: 'get'
    })
}

// 获取测评报告列表
export function getEvaluationReportList(params) {
    return request({
        url: `/system/server-system/evaluationReport/list`,
        method: 'get',
        params
    })
}

// 获取用户签到活动数据
export function getUserEventCheckPoints() {
    return request({
        url: `/system/server-system/eventCheck/ponits/getUserEventCheckPonits`,
        method: 'get'
    })
}

// 用户签到接口
export function addUserCheck() {
    return request({
        url: `/system/server-system/eventCheck/addUserCheck`,
        method: 'post'
    })
}

// 获取我的营销活动（任务列表）
export function getMyMarketing() {
    return request({
        url: `/system/server-system/marketingActivity/getMyMarketing`,
        method: 'get'
    })
}

// 获取营销活动详情
export function getMarketingActivityDetail(id) {
    return request({
        url: `/system/server-system/marketingActivity/${id}`,
        method: 'get'
    })
}

// 完成任务
export function addUserMarketingActivity(marketingId) {
    return request({
        url: `/system/server-system/marketingActivity/addUserMarketingActivity/${marketingId}`,
        method: 'post'
    })
}

// 检查家长绑定完成状态
export function getParentsCheck() {
    return request({
        url: `/system/server-system/marketingActivity/getParentsCheck`,
        method: 'get'
    })
}

// 轮播图点击量上报
export function clickSlideItem(id) {
    return request({
        url: `/oauth/server-oauth/slideItems/click/${id}`,
        method: 'get'
    })
}